import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAlignVerticalCenter: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="align-vertical-center, alignment"><path d="M20.25 3.75V20.25H3.75V3.75H20.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M7.75 12H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconAlignVerticalCenter;
